import React from 'react';
import { cn } from '../lib/utils';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string | null;
  alt?: string;
  fallback: string;
  size?: 'sm' | 'md' | 'lg';
}

function Avatar({ src, alt, fallback, size = 'md', className, ...props }: AvatarProps) {
  const sizeClasses = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base',
  };

  if (src) {
    return (
      <img
        src={src}
        alt={alt ?? fallback}
        className={cn('shrink-0 rounded-full object-cover', sizeClasses[size], className)}
        data-ui="Avatar"
        data-avatar-kind="image"
        {...props}
      />
    );
  }

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full bg-statura-green-accessible font-body font-semibold text-white',
        sizeClasses[size],
        className,
      )}
      data-ui="Avatar"
      data-avatar-kind="initials"
      {...props}
    >
      {fallback}
    </div>
  );
}

export { Avatar };
